import script from "./BulkAddNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkAddNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./BulkAddNoteForm.vue?vue&type=style&index=0&id=37697189&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37697189"]])

export default __exports__